const hasDisplayTimes = (itemData) => {
    return  (itemData.hasOwnProperty('displayDateStart') && itemData.displayDateStart) || 
            (itemData.hasOwnProperty('displayDateEnd') && itemData.displayDateEnd)
}

export default hasDisplayTimes